var exports = {
  "KE": "toolbar__qXTd3l",
  "Qg": "selectAllLabel__mzKxGd",
  "aP": "box__MvdB06",
  "ej": "requestRow__K8PdIu",
  "cL": "checkboxAndAvatar__-lf2xg",
  "my": "avatar__NwPEHA",
  "t$": "requestMeta__VhPntC",
  "SZ": "titleAndTimestamp__8ArhV4",
  "ze": "currentBudget__gYAVBa",
  "K3": "newBudgetLabel__mhH1pH",
  "HV": "budgetComparison__ird9Xh",
  "yF": "divider__YZsaS5",
  "Yf": "newBudgetField__GZ6GIf",
  "JV": "amountInput__cE7dUh",
};

module.exports = exports;
